import {Component, Inject, Input, OnInit} from '@angular/core';
import {TaskService} from "../../services/task.service";
import {AbstractControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {Router} from "@angular/router";
import {ProcessDefinitionService} from "../../services/definitions.service";
import {ProcessService} from "../../services/process.service";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import { algAuthorizationHeader } from '../../alg-auth';

@Component({
  standalone: false,
  selector: 'app-form',
  templateUrl: './form.html',
  styleUrls: ['./form.css', './form-actions.css'],
})
export class FormComponent implements OnInit {
  private apiUrl =  window.location.origin + '/alfresco/api/-default-/public/alfresco/versions/1';

  @Input() form: FormGroup;
  @Input() formProperties: any[];
  @Input() type: string;
  @Input() selectFiles: boolean;
  @Input() processKey: any;
  @Input() items: any;
  @Input() new: boolean = false;
  @Input() context: any = null;

  taskSelected: any;


  filteredItems: any = [];
  selectedFiles: any = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: { obj: any },
              private router: Router,
              private taskService: TaskService,
              private processDefinitionService: ProcessDefinitionService,
              private processService: ProcessService,
              private http: HttpClient,
              private authService: AuthenticationService,
              public dialog: MatDialog) {
  }

  ngOnInit() {
    this.items?.list?.entries.forEach(item => {
      this.getNode(item.entry.id).subscribe((node: any) => {
        item.entry.parentId = node.entry.parentId;
      });
    });
    const contextNode = this.context?.node?.entry || this.context?.node || this.context?.entry || this.context;
    if(contextNode?.isFile) {
      this.selectedFiles = [{'entry' : contextNode}];
    }
  }

  outcomeTask(option: any) {
    this.taskSelected = this.data.obj.id;
    let data = this.formatData();
    const outcome = this.formProperties.find((field) => this.isOutcome(field));
    data = data.filter((variable) => variable.name !== outcome?.id.replace(':', '_'));
    data.push({
      "name": (outcome?.id || "wf:reviewOutcome").replace(':', '_'),
      "value": option,
      'scope': 'global'
    })
    this.taskService.postTask(this.taskSelected, data).subscribe(() => {
      this.taskService.putTask(this.taskSelected, {"state": "completed"}).subscribe(() => {
        this.dialog.closeAll();
      });
    });
  }

  submit(type: string) {
    switch (type) {
      case 'editTask':
        this.submitEditTask();
        break;
      case 'newProcess':
        this.submitNewProcess();
        break;
    }
  }

  submitNewProcess() {
    let data = {};
    Object.keys(this.form.controls).forEach(key => {
      data[key.replace(':', '_')] = this.normalizedValue(key);
    });
    let body = {
      processDefinitionKey: this.processKey.key,
      variables: data
    }
    let items = this.selectedFiles?.map(item => {
      return {
        id: item.entry.id,
      }
    });
    this.processService.createProcess(body).subscribe((process: any) => {
      if (this.selectedFiles?.length > 0) {
        this.processService.postItemsToProcess(process.entry.id, items).subscribe(() => {
          this.dialog.closeAll();

          //rafraichir la liste des process
        });
      } else {
        this.dialog.closeAll();
      }
    });
  }

  submitEditTask() {
    this.taskSelected = this.data.obj.id;
    let variables = this.formatData();
    this.taskService.postTask(this.taskSelected, variables).subscribe(() => {
      this.dialog.closeAll();
    });
  }

  formatData() {
    let data = [];
    Object.keys(this.form.controls).forEach(key => {
      data.push({
        "name": key.replace(':', '_'),
        "value": this.normalizedValue(key),
        'scope': key === 'bpm:comment' ? 'global' : 'local'
      })
    });
    return data;
  }

  private normalizedValue(key: string): any {
    const value = this.form.controls[key]?.value;
    const field = this.formProperties.find((candidate) => candidate.id === key);
    const expectsArray = this.isMultiValuedField(field);
    if (expectsArray) {
      if (Array.isArray(value)) return value.filter(Boolean);
      if (typeof value === 'string') return value.split(',').map((item) => item.trim()).filter(Boolean);
      return value == null ? [] : [value];
    }
    return value;
  }

  isOutcome(field: any): boolean { return /reviewOutcome$/i.test(field?.id || ''); }
  isAssociation(field: any): boolean { return !field?.dataType && !!field?.target; }
  isMultiValuedField(field: any): boolean {
    return field?.isMultiValued === true || field?.multiValued === true || field?.target?.isMany === true;
  }
  associationValues(field: any): string[] {
    const value = this.control(field)?.value;
    return Array.isArray(value) ? value : value ? [value] : [];
  }
  addAssociationValue(field: any, value: string): void {
    const normalized = value?.trim();
    if (!normalized) return;
    const values = this.associationValues(field);
    if (!values.includes(normalized)) this.control(field)?.setValue([...values, normalized]);
  }
  removeAssociationValue(field: any, value: string): void {
    this.control(field)?.setValue(this.associationValues(field).filter((candidate) => candidate !== value));
  }
  isWorkflowField(field: any): boolean { return /^(bpm|wf):/.test(field?.id || '') && !this.isOutcome(field); }
  get businessFields(): any[] { return (this.formProperties || []).filter((field) => !this.isWorkflowField(field) && !this.isOutcome(field)); }
  get workflowFields(): any[] { return (this.formProperties || []).filter((field) => this.isWorkflowField(field)); }
  allowedValues(field: any): any[] { return field?.constraints?.find((constraint) => constraint.type === 'LIST')?.parameters?.allowedValues || []; }
  hasList(field: any): boolean { return this.allowedValues(field).length > 0; }
  control(field: any): AbstractControl | null { return this.form?.get(field?.id) || null; }
  fieldError(field: any): string {
    const control = this.control(field);
    if (!control?.touched || !control.errors) return '';
    if (control.errors['required']) return 'Ce champ est obligatoire';
    if (control.errors['minlength']) return `Minimum ${control.errors['minlength'].requiredLength} caractères`;
    if (control.errors['maxlength']) return `Maximum ${control.errors['maxlength'].requiredLength} caractères`;
    return 'Valeur incorrecte';
  }

  get documentContext(): any {
    const selected = this.context?.node?.entry || this.context?.node || this.context?.entry;
    return selected?.isFile ? selected : selected?.isFolder ? selected : this.context?.currentFolder;
  }

  linkClick() {
    this.router.navigate(['view', {outlets: {viewer: ["b21beae0-97c1-4cd8-887d-dd5d547b417b"]}}]);
  }

  filterItems($event: any, formControlName) {
    if ($event.value.length > 2) {
      this.processDefinitionService.search($event.value).subscribe((items: any) => {
        this.filteredItems[formControlName] = items.list.entries;
      });
    }
  }

  getNode(nodeId: string): Observable<any> {
    const endpoint = `${this.apiUrl}/nodes/${nodeId}`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(endpoint, params);
  }
}
